/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { useEcho } from '@storable/echo';
import { Notification, Button, Modal } from '@storable/canaveral-components';

const propTypes = {};

const defaultProps = {};

const EchoNotifications = () => {
  const [current, setCurrent] = useState();
  const { notifications } = useEcho();

  const onAcknowledgeNotification = (notification) => {
    notification.acknowledge();
    notification.dismiss();
    setCurrent(notification);
  };

  const onDismissNotification = (notification) => {
    notification.dismiss();
  };

  const onDismissModal = () => {
    setCurrent();
  };

  return (
    <React.Fragment>
      {notifications
        .filter(notification => !notification.dismissed)
        .map(notification => (
          <Notification
            key={notification.id}
            onDismiss={() => onDismissNotification(notification)}
            show
          >
            <Notification.Header>
              <Notification.Title>
                {notification.title}
              </Notification.Title>
            </Notification.Header>
            <Notification.Body>
              {notification.summary}
            </Notification.Body>
            <Notification.Footer>
              <Button
                context="link"
                onClick={() => onAcknowledgeNotification(notification)}
              >
                Learn more
              </Button>
            </Notification.Footer>
          </Notification>
        ))}
      <Modal
        show={!!current}
        onDismiss={onDismissModal}
      >
        <Modal.Body>
          {current && (
            <div dangerouslySetInnerHTML={{ __html: current.body }} />
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

EchoNotifications.propTypes = propTypes;
EchoNotifications.defaultProps = defaultProps;

export default EchoNotifications;
